import type { NomadDB } from '~/db/NomadDB';
import type { TaskSchema } from '@/types/schema';

export const getTasksService = (db: NomadDB) => {
  const findByState = async (state: string) => {
    return await db.tasks.where('state').equals(state).toArray();
  };

  const findByType = async (type: string) => {
    return await db.tasks.where('type').equals(type).toArray();
  };

  const bulkPut = async (data: TaskSchema[]): Promise<void> => {
    await db.tasks.bulkPut(data);
  };

  const findAll = async (): Promise<TaskSchema[]> => {
    return await db.tasks.toArray();
  };

  const deleteById = async (id: string): Promise<void> => {
    await db.tasks.where('id').anyOf([id]).delete();
  };

  return {
    findByState,
    bulkPut,
    findByType,
    findAll,
    deleteById,
  };
};
